import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './login.css';

const Login = () => {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const submitHandler = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post('https://pkrealestateapi.onrender.com/auth/admin/login', {
                userName,
                password
            });

            
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('email', response.data.email);
            localStorage.setItem('fullName', response.data.fullName);
            localStorage.setItem('userType', 'admin'); 

            
            setError('');

            
            navigate('/admin/dashboard', { replace: true });
        } catch (err) {
            console.error('Login error:', err);
            setError(
                err.response?.data?.message || 
                'Login failed. Please check your credentials.'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <form onSubmit={submitHandler} className="login">
                <header>Admin Login</header>
                
                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}

                <input 
                    type="text"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    placeholder="Username"
                    required 
                />
                
                <input 
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required 
                />
                
                <button 
                    className="button" 
                    type="submit" 
                    disabled={loading}
                >
                    {loading ? 'Logging in...' : 'Login'}
                </button>

                {loading && (
                    <div className="loader">
                        Loading...
                    </div>
                )}
            </form>
        </div>
    );
};

export default Login;